import { OnlyMyTimesheetsCheckboxToggleAction } from './types';
import { ONLY_MY_TIMESHEETS_CHECKBOX_TOGGLE } from './constants';

export const onlyMyTimesheetsCheckboxToggle = (): OnlyMyTimesheetsCheckboxToggleAction => {
    return {
        type: ONLY_MY_TIMESHEETS_CHECKBOX_TOGGLE
    };
};
